import React, { useEffect, useState } from "react";
import "./RoleAccessMain.css";
import DepartmentsListWithUsers from "./DepartmentsListWithUsers";
import RoleAccessForm from "./RoleAccessForm";
import { userRole } from "../../constants/Helper/getUserRole";
import { checkUserTabAccess } from "../../constants/Helper/checkUserTabAccess";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const RoleAccessMain = () => {
  const [userId, setuserId] = useState("");
  const navigate = useNavigate();

  const handleUserIdChange = (id) => {
    setuserId(id);
  };

  useEffect(() => {
    if (!checkUserTabAccess("Role_Access") || userRole() == "zonal") {
      toast.info("You do not have permission to access Role Access");
      navigate(-1); // redirect to previous page if user dont not have Tab Access
      return;
    }
  }, []);

  return (
    <>
      <div className="RoleAccessMain w-100">
        <div className="row w-100 h-100 mx-auto">
          {/* Left Column */}
          <div className="col-md-4 d-flex flex-column h-100">
            <div className="common_shadow rounded p-3 bg-white h-100">
              <DepartmentsListWithUsers
                handleUserIdChange={handleUserIdChange}
                userId={userId}
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="col-md-8 d-flex flex-column h-100">
            <div className="h-100">
              <RoleAccessForm userId={userId} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleAccessMain;
